
    var riot = require('riot')
    //src: starling/src/tags/sidebar.html
riot.tag2('sidebar',
  '<button id="sidebar-close-button" class="Button Button--Link Button--Icon" onclick="{canvas.closeSidebar}"> <svg class="Button__Icon"> <use xlink:href="#close-icon"></use> </svg> </button> <div if="{window.user && !window.user.closed_help && window.user.total_operations !== undefined && window.user.total_operations > 10}" class="sidebar-tooltip"> <span class="fw-bold">Hi there!</span> <span>Learn about new features in our user guide</span> </div> <shortcuts-help canvas="{this.canvas}" id="shortcuts-help" hide="{this.canvas.sidebarStatus !== \'shortcuts\'}"></shortcuts-help> <user-guide canvas="{this.canvas}" hide="{this.canvas.sidebarStatus !== \'user-guide\'}"></user-guide> <user-settings canvas="{this.canvas}" hide="{this.canvas.sidebarStatus !== \'user-settings\'}"></user-settings> <comments-sidebar canvas="{this.canvas}" hide="{this.canvas.sidebarStatus !== \'comments\'}"></comments-sidebar> <div class="sidebar-switcher" hide="{this.canvas.sidebarStatus ===\'user-settings\'}" onclick="{this.canvas.sidebarStatus === \'user-guide\' ?                 this.canvas.openSidebar.bind(this.canvas, \'shortcuts\') :                 this.canvas.openSidebar.bind(this.canvas, \'user-guide\')}"> <div hide="{this.canvas.sidebarStatus !== \'shortcuts\'}" class="sidebar-tab user-guide-tab"> <i class="material-icons">assignment</i> <span>View user guide</span> </div> <div hide="{this.canvas.sidebarStatus !== \'user-guide\'}" class="sidebar-tab shortcut-tab"> <i class="material-icons">keyboard</i> <span>View keyboard shortcuts</span> </div> </div>',
  '',
  'onmouseenter="{this.handleMouseEnter}" onmouseleave="{this.handleMouseLeave}" ref="sidebar" id="right-sidebar" class="hideWhenPresenting"', function(opts) {
'use strict';

var _this = this;

this.canvas = this.opts.canvas;
this.canvas.sidebarTag = this;

if (window.Intercom) {
  Intercom('onShow', function () {
    if (_this.canvas.sidebarStatus !== 'closed') {
      setTimeout(function () {
        $('.intercom-messenger-frame').each(function () {
          this.style.setProperty('right', '420px', 'important');
        });
      }, 100);
    }
  });
}

this.on('updated', function () {
  var canvas = _this.canvas;
  var sidebarStatus = canvas.sidebarStatus;

  if (sidebarStatus === 'user-guide') {
    $(canvas.userGuideTag.refs.search).focus();
  }

  if (sidebarStatus === 'closed') {
    canvas.userGuideTag.resetSearch();
  }
});

this.on('mount', function () {
  if (window.user && !window.user.closed_help) {
    window.setTimeout(function () {
      return $('.sidebar-tooltip').addClass('hidden-fade-out');
    }, 10000);
  }
  _this.canvas.attachRightClickDismissEvent(_this.refs.sidebar);
});

$(this.refs.sidebar).on('mousedown touchstart pointerdown', function (e) {
  e.stopImmediatePropagation();
});

this.handleMouseEnter = function (e) {
  $(_this.canvas.refs.canvas).panzoom('disable');
};

this.handleMouseLeave = function (e) {
  $(_this.canvas.refs.canvas).panzoom('enable');
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('sidebar')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/sidebar.html
// module id = 587
// module chunks = 0